import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let ready = false;

export function initAnalytics() {
  if (ready || typeof window === "undefined") return;
  if (!KEY) {
    // no key configured — skip silently in dev / preview environments
    return;
  }
  posthog.init(KEY, {
    api_host: HOST,
    // cookieless: no localStorage / cookies → no consent banner needed,
    // each tab is a fresh anonymous identity
    persistence: "memory",
    // autocapture: clicks on <a>, <button>, <form> are captured automatically
    autocapture: true,
    // we trigger $pageview manually on each route change (HashRouter)
    capture_pageview: false,
    // keep session recordings OFF to avoid quota / cost
    disable_session_recording: true,
    // don't capture sensitive form input text
    mask_all_text: false,
    loaded: () => {
      ready = true;
    },
  });
  ready = true;
}

export function trackPageview() {
  if (!ready || !KEY) return;
  try {
    // HashRouter URLs look like /#/cv — re-write to /cv for cleaner analytics
    const hash = (window.location.hash || "").replace(/^#/, "") || "/";
    const cleanUrl = window.location.origin + hash;
    posthog.capture("$pageview", {
      $current_url: cleanUrl,
      $pathname: hash.split("?")[0],
    });
  } catch (_) {
    /* swallow */
  }
}

export function track(event, properties) {
  if (!ready || !KEY) return;
  try {
    posthog.capture(event, properties);
  } catch (_) {
    /* swallow */
  }
}

export default posthog;
